// extracted by css-extract-rspack-plugin
export default {"setOffset":"_e75b8c4a","viewportContainer":"_8a88d7b6"};